/* tslint:disable */

declare var Object: any;
export interface TtamshiftdailyInterface {
  "shiftdailycode": string;
  "companyId": number;
  "starttime"?: Date;
  "endtime"?: Date;
  "productivehours": number;
  "daytype": string;
  "flexibleshift": string;
  "graceforlate"?: number;
  "graceEai"?: number;
  "graceLti"?: number;
  "graceEao"?: number;
  "graceLto"?: number;
  "gracebreakEai"?: number;
  "gracebreakLti"?: number;
  "gracebreakEao"?: number;
  "gracebreakLto"?: number;
  "overtimecode": string;
  "overtimecodePh": string;
  "automaticovtType"?: string;
  "automaticovtStart"?: Date;
  "automaticovtEnd"?: Date;
  "autoovtminutes"?: number;
  "ovtBeforeend"?: Date;
  "ovtAfterstart"?: Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "remark"?: string;
  "breakovtCalculation"?: string;
  "shiftdailycodeph"?: string;
  "ovtAfterstartMnt"?: number;
  "overtimecodeSd"?: string;
  "overtimecodeRestd"?: string;
  "overtimecodePhrestd"?: string;
  "overtimecodeSdrestd"?: string;
  "overtimecodeInside"?: string;
  "color"?: string;
  shiftbreak?: any[];
}

export class Ttamshiftdaily implements TtamshiftdailyInterface {
  "shiftdailycode": string;
  "companyId": number;
  "starttime": Date;
  "endtime": Date;
  "productivehours": number;
  "daytype": string;
  "flexibleshift": string;
  "graceforlate": number;
  "graceEai": number;
  "graceLti": number;
  "graceEao": number;
  "graceLto": number;
  "gracebreakEai": number;
  "gracebreakLti": number;
  "gracebreakEao": number;
  "gracebreakLto": number;
  "overtimecode": string;
  "overtimecodePh": string;
  "automaticovtType": string;
  "automaticovtStart": Date;
  "automaticovtEnd": Date;
  "autoovtminutes": number;
  "ovtBeforeend": Date;
  "ovtAfterstart": Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "remark": string;
  "breakovtCalculation": string;
  "shiftdailycodeph": string;
  "ovtAfterstartMnt": number;
  "overtimecodeSd": string;
  "overtimecodeRestd": string;
  "overtimecodePhrestd": string;
  "overtimecodeSdrestd": string;
  "overtimecodeInside": string;
  "color": string;
  shiftbreak: any[];
  constructor(data?: TtamshiftdailyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamshiftdaily`.
   */
  public static getModelName() {
    return "Ttamshiftdaily";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamshiftdaily for dynamic purposes.
  **/
  public static factory(data: TtamshiftdailyInterface): Ttamshiftdaily{
    return new Ttamshiftdaily(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamshiftdaily',
      plural: 'Ttamshiftdailies',
      path: 'Ttamshiftdailies',
      properties: {
        "shiftdailycode": {
          name: 'shiftdailycode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "starttime": {
          name: 'starttime',
          type: 'Date'
        },
        "endtime": {
          name: 'endtime',
          type: 'Date'
        },
        "productivehours": {
          name: 'productivehours',
          type: 'number'
        },
        "daytype": {
          name: 'daytype',
          type: 'string'
        },
        "flexibleshift": {
          name: 'flexibleshift',
          type: 'string'
        },
        "graceforlate": {
          name: 'graceforlate',
          type: 'number'
        },
        "graceEai": {
          name: 'graceEai',
          type: 'number'
        },
        "graceLti": {
          name: 'graceLti',
          type: 'number'
        },
        "graceEao": {
          name: 'graceEao',
          type: 'number'
        },
        "graceLto": {
          name: 'graceLto',
          type: 'number'
        },
        "gracebreakEai": {
          name: 'gracebreakEai',
          type: 'number'
        },
        "gracebreakLti": {
          name: 'gracebreakLti',
          type: 'number'
        },
        "gracebreakEao": {
          name: 'gracebreakEao',
          type: 'number'
        },
        "gracebreakLto": {
          name: 'gracebreakLto',
          type: 'number'
        },
        "overtimecode": {
          name: 'overtimecode',
          type: 'string'
        },
        "overtimecodePh": {
          name: 'overtimecodePh',
          type: 'string'
        },
        "automaticovtType": {
          name: 'automaticovtType',
          type: 'string'
        },
        "automaticovtStart": {
          name: 'automaticovtStart',
          type: 'Date'
        },
        "automaticovtEnd": {
          name: 'automaticovtEnd',
          type: 'Date'
        },
        "autoovtminutes": {
          name: 'autoovtminutes',
          type: 'number'
        },
        "ovtBeforeend": {
          name: 'ovtBeforeend',
          type: 'Date'
        },
        "ovtAfterstart": {
          name: 'ovtAfterstart',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "breakovtCalculation": {
          name: 'breakovtCalculation',
          type: 'string'
        },
        "shiftdailycodeph": {
          name: 'shiftdailycodeph',
          type: 'string'
        },
        "ovtAfterstartMnt": {
          name: 'ovtAfterstartMnt',
          type: 'number'
        },
        "overtimecodeSd": {
          name: 'overtimecodeSd',
          type: 'string'
        },
        "overtimecodeRestd": {
          name: 'overtimecodeRestd',
          type: 'string'
        },
        "overtimecodePhrestd": {
          name: 'overtimecodePhrestd',
          type: 'string'
        },
        "overtimecodeSdrestd": {
          name: 'overtimecodeSdrestd',
          type: 'string'
        },
        "overtimecodeInside": {
          name: 'overtimecodeInside',
          type: 'string'
        },
        "color": {
          name: 'color',
          type: 'string'
        },
      },
      relations: {
        shiftbreak: {
          name: 'shiftbreak',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamshiftdaily.ts